/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  computed,
  ComputedRef,
  defineComponent,
  Ref,
  unref,
} from 'vue'
import { VNode } from 'vue'

export const ComponentName = 'storage-tips'

type MaybeRef<T> = T | ComputedRef<T> | Ref<T>
type MaybeFn<T> = () => MaybeRef<T>

function isFn<T>(v: any): v is MaybeFn<T> {
  return typeof v === 'function'
}

export function createStorageTipsComponent<T = boolean>(
  disabled: MaybeRef<T> | MaybeFn<T>,
  config?: {
    name?: string
    content?: string
    i18nKey?: string
  },
) {
  const name = config?.name || ComponentName
  return defineComponent({
    name: name,
    props: {
      isStorageFull: {
        type: Boolean,
        default: undefined,
      },
    },
    setup(props) {
      return {
        isDisabled:
          // eslint-disable-next-line no-nested-ternary
          typeof props.isStorageFull === 'undefined'
            ? isFn<T>(disabled)
              ? computed(disabled)
              : disabled
            : computed(() => props.isStorageFull),
      }
    },
    render(createElement) {
      let content =
        config?.content ||
        '存储空间已满，无法进行操作。请清理资产库数据或联系销售进行空间扩容。'
      if (isFn(this.$t)) {
        if (config && config.i18nKey) {
          content = config?.content || this.$t(config.i18nKey).toString()
        } else {
          content =
            config?.content || this.$t('basic.storagefull.tips').toString()
        }
      }
      const isDisabled = unref(this.isDisabled)
      const children = this.$scopedSlots.default?.({
        disabled: isDisabled,
      })

      if (!isDisabled) {
        return children as unknown as VNode
      }

      if (children) {
        return createElement(
          'ElTooltip',
          {
            props: {
              placement: 'top',
              content,
              ...(this.$attrs || {}),
              ...(this.$props || {}),
            },
          },

          [...children],
        )
      }

      return null as unknown as VNode
    },
  })
}
